import React from 'react';
import { reduxForm, Field, FieldArray } from 'redux-form';

import { CSSTransitionGroup } from 'react-transition-group';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

import { TextField } from 'redux-form-material-ui';
import TransactionCard from '@material-ui/core/Card';
import IconButton from 'material-ui/IconButton';
import FlatButton from 'material-ui/FlatButton';
import { MdDelete as DeleteIcon } from 'react-icons/md';
import { MdDragHandle as DragIcon } from 'react-icons/md';

import Header from 'components/shared/Header';

import { AccentColor } from 'helpers/AccentColorHelper';
import { colors } from 'helpers/ColorHelper';
import { required } from 'helpers/Validator';
import { RenderError } from 'components/shared/RenderError';

import validate from './validate';

const styles = {
  transactionCard: {
    background: colors.LIGHTEST_GRAY,
    width: '99%',
    marginLeft: '1px',
    marginBottom: '25px',
  },
  deleteRoomButton: {
    verticalAlign: 'top',
    paddingLeft: '0',
    width: '30px',
  },
};

const InspectionRoom = ({ fields, room, index }) => (
  <Draggable key={room} draggableId={room} index={index}>
    {(provided, snapshot) => (
      <div
        ref={provided.innerRef}
        {...provided.draggableProps}
        {...provided.dragHandleProps}
        style={provided.draggableProps.style}
      >
        <TransactionCard key={room} style={styles.transactionCard}>
          <Header name={`INSPECTION AREA ${index + 1}`} />
          <div className="row" style={{ padding: '15px 0 5px 15px' }}>
            <div className="col-xs-1">
              <span>
                <DragIcon width={30} height={30} style={{ paddingTop: '8px' }} />
              </span>
            </div>
            <div className="col-xs-9">
              <Field
                name={`${room}.name`}
                component={TextField}
                hintText="Inspection Area"
                floatingLabelText="Inspection Area"
                validate={required}
                style={{ margin: '0px', fontFamily: 'Circular-Black', marginTop: '-23px' }}
                fullWidth
              />
            </div>
            <div className="col-xs-2" style={{ textAlign: 'center' }}>
              <IconButton style={styles.deleteRoomButton} onClick={() => fields.remove(index)}>
                <DeleteIcon size={24} style={{ padding: 0 }} />
              </IconButton>
            </div>
          </div>
        </TransactionCard>
      </div>
    )}
  </Draggable>
);

class InspectionRooms extends React.Component {
  onDragEnd = ({ source, destination }) => {
    if (!destination) return; // dropped outside of list

    this.props.fields.move(source.index, destination.index);
  };

  render() {
    return (
      <DragDropContext onDragEnd={this.onDragEnd}>
        <Droppable droppableId="droppable">
          {(provided, snapshot) => (
            <div ref={provided.innerRef}>
              <CSSTransitionGroup
                transitionName="add_inspection_item"
                transitionEnterTimeout={200}
                transitionLeaveTimeout={200}
              >
                {this.props.fields.map((room, index) => (
                  <InspectionRoom key={room} room={room} fields={this.props.fields} index={index} />
                ))}
              </CSSTransitionGroup>
            </div>
          )}
        </Droppable>

        <FlatButton
          label="Add Additional Area"
          type="button"
          backgroundColor={AccentColor()}
          hoverColor="grey"
          style={{ color: 'white', margin: '25px auto 50px auto', display: 'block' }}
          onClick={() => this.props.fields.push({ inspects: [{ field_type: 'condition' }] })}
        />
      </DragDropContext>
    );
  }
}

export default reduxForm({
  destroyOnUnmount: false,
  validate,
})((props) => (
  <form>
    <Field component={RenderError} name="details_page_errors" />
    <FieldArray name="inspection_rooms" component={InspectionRooms} />
    <div style={{ height: '150px' }} />
  </form>
));
